var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmenticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 36.75C7.7875 36.75 6.96354 36.4073 6.27812 35.7219C5.59271 35.0365 5.25 34.2125 5.25 33.25V8.75C5.25 7.7875 5.59271 6.96354 6.27812 6.27812C6.96354 5.59271 7.7875 5.25 8.75 5.25H16.1C16.4792 4.2 17.1135 3.35417 18.0031 2.7125C18.8927 2.07083 19.8917 1.75 21 1.75C22.1083 1.75 23.1073 2.07083 23.9969 2.7125C24.8865 3.35417 25.5208 4.2 25.9 5.25H33.25C34.2125 5.25 35.0365 5.59271 35.7219 6.27812C36.4073 6.96354 36.75 7.7875 36.75 8.75V33.25C36.75 34.2125 36.4073 35.0365 35.7219 35.7219C35.0365 36.4073 34.2125 36.75 33.25 36.75H8.75ZM12.25 29.75H24.5V26.25H12.25V29.75ZM12.25 22.75H29.75V19.25H12.25V22.75ZM12.25 15.75H29.75V12.25H12.25V15.75ZM21 7.4375C21.3792 7.4375 21.6927 7.31354 21.9406 7.06562C22.1885 6.81771 22.3125 6.50417 22.3125 6.125C22.3125 5.74583 22.1885 5.43229 21.9406 5.18437C21.6927 4.93646 21.3792 4.8125 21 4.8125C20.6208 4.8125 20.3073 4.93646 20.0594 5.18437C19.8115 5.43229 19.6875 5.74583 19.6875 6.125C19.6875 6.50417 19.8115 6.81771 20.0594 7.06562C20.3073 7.31354 20.6208 7.4375 21 7.4375Z",
    fill: "#D9E8F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmenticon);
export default __webpack_public_path__ + "static/media/assessment+icon.e12a9b6a4972d6f0ab5e5cfb76235b7b.svg";
export { ForwardRef as ReactComponent };